/**
 * Layout Constants - Single Source of Truth
 * Valores baseados em iOS Human Interface Guidelines
 * 
 * ARQUITETURA iOS NATIVA (Capacitor):
 * ┌─────────────────────────────────────────────────┐
 * │ StatusBar (nativo iOS) - SOBERANO              │
 * ├─────────────────────────────────────────────────┤
 * │ Header Social (44px) - FIXO, nunca scrolla     │
 * ├─────────────────────────────────────────────────┤
 * │ Content - ÚNICO elemento scrollável            │
 * ├─────────────────────────────────────────────────┤
 * │ Tab Bar (56px) - FIXO, nunca scrolla           │
 * └─────────────────────────────────────────────────┘
 */

// iOS standard navigation bar height (sem safe area) + respiro visual
export const HEADER_CONTENT_HEIGHT = 52;

// iOS tab bar height (sem safe area) + respiro visual
export const BOTTOMNAV_HEIGHT = 64;

// Safe area fallbacks para dispositivos com notch/Dynamic Island
// iPhone 14 Pro, 15 Pro, 16 Pro = 59px
export const SAFE_AREA_TOP_FALLBACK = 59;
// iPhone home indicator
export const SAFE_AREA_BOTTOM_FALLBACK = 34;

// Android status bar fallback
export const ANDROID_STATUS_BAR_HEIGHT = 24;

// z-index scale - hierarquia clara
export const Z_INDEX = {
  map: 1,
  content: 10,
  bottomNav: 9998,
  header: 9999,
  modal: 10000,
} as const;

// CSS env() strings para uso inline
export const CSS_SAFE_AREA = {
  top: `env(safe-area-inset-top, ${SAFE_AREA_TOP_FALLBACK}px)`,
  bottom: `env(safe-area-inset-bottom, ${SAFE_AREA_BOTTOM_FALLBACK}px)`,
} as const;

// Computed heights (para uso no JS quando necessário)
export const getHeaderTotalHeight = (safeAreaTop: number = SAFE_AREA_TOP_FALLBACK) => 
  HEADER_CONTENT_HEIGHT + safeAreaTop;

export const getBottomNavTotalHeight = (safeAreaBottom: number = SAFE_AREA_BOTTOM_FALLBACK) => 
  BOTTOMNAV_HEIGHT + safeAreaBottom;
